<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<h1>{{supplierName}}</h1>
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增咨询选项</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button v-if="row.status==1" type="warning" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,0)">停用</Button>
					<Button v-if="row.status==0" type="success" size="small" style="margin-right: 5px"
						@click="updateStatus(row.id,1)">启用</Button>
					<Button type="error" size="small" style="margin-right: 5px" @click="delData(row.id)">删除</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addStoreShow" :title="addForm.id?'编辑咨询选项':'新增咨询选项'">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="咨询选项名称" prop="optionName">
					<Input v-model="addForm.optionName" placeholder="请输入咨询选项名称"></Input>
				</FormItem>
				<FormItem label="咨询选项编码" prop="optionKey">
					<Input v-model="addForm.optionKey" placeholder="请输入咨询选项编码"></Input>
				</FormItem>
				<FormItem label="状态" prop="status">
					<i-switch v-model="addForm.status" size="large">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateData">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				supplierName: this.$route.query.name,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				addForm: {
					optionName: '',
					optionKey: '',
					status: true,
				},
				addRule: {
					optionName: [
						{ required: true, message: '请输入广告key', trigger: 'blur' }
					],
					optionKey: [
						{ required: true, message: '请输入广告名称', trigger: 'blur' },
					],
					status: [
						{ required: true, type: 'boolean', message: '请选择状态', trigger: 'blur' }
					],
				}
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '咨询选项名称',
						key: 'optionName',
						align: 'center'
					},
					{
						title: '咨询选项编码',
						key: 'optionKey',
						align: 'center'
					},
					{
						title: '状态',
						key: 'status',
						align: 'center',
						render: (h, params) => {
							return h('span', params.row.status == 1 ? '启用' : '停用');
						}

					}, {
						title: '创建日期',
						key: 'createTime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1,
					this.queryData = []
				this.getData()
			},
			getData() {
				this.loading = true
				const queryParams = {
					id: this.$route.query.id,
					page: this.pageNum,
					limit: this.pageSize
				}
				api.statistics
					.getNewsSupplierOptions(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateData() {
				const that = this
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						let params = { ...that.addForm }
						params.status = params.status ? 1 : 0
						params.supplierId = this.$route.query.id
						api.statistics
							.addOrEditNewsOption(params)
							.then(res => {
								that.$Message.success('Success!');
								if (that.addForm.id) {
									//编辑
									that.queryData.forEach(item => {
										if (item.id == that.addForm.id) {
											item.status = that.addForm.status
											item.optionKey = that.addForm.optionKey
											item.optionName = that.addForm.optionName
										}
									})
								} else {
									//新增
									that.refreshData()
								}
								that.addStoreShow = false
							})
							.catch(err => {
								that.$Message.error('新增失败: ' + err.message)
							})

					}
				})
			},

			updateStatus(id, status) {
				const that = this
				api.statistics
					.addOrEditNewsOption({ 'id': id, status: status })
					.then(res => {
						that.$Message.success('Success!');
						that.queryData.forEach(item => {
							if (item.id == id) {
								item.status = status
							}
						})
					})
			},
			addShow() {
				this.addForm = {
						optionName: '',
						optionKey: '',
						status: true,
					},
					this.addStoreShow = true
			},
			editData(rowData) {
				this.addForm = {
						id: rowData.id,
						optionName: rowData.optionName,
						optionKey: rowData.optionKey,
						status: rowData.status == 1 ? true : false,
					},
					this.addStoreShow = true

			},
			delData(id) {
				const that = this
				that.$Modal.confirm({
					title: '操作确认',
					content: '数据删除不可恢复，确定删除吗？',
					onOk: function() {
						api.statistics
							.delNewsOption({ 'id': id })
							.then(res => {
								that.$Message.success('Success!');
								that.refreshData()
							})
					}
				})

			},
		},



	}
</script>
